import React from 'react';
import { FilterSelectNative } from '@/components/custom/filter';
import { FormCheck } from '@/components/custom/form';

/**
 * Filtros legados (modalidade + inéditas + busca, todos client-side).
 * Usado nos fluxos de provas e apostilas — o filtro GATE fica restrito a simulados.
 */
export default function LegacyFilters({ filters, modalitys, t }) {
  return (
    <div className="filter-bar">
      <div className="filter-bar__inner">
        <FilterSelectNative
          label={t('filter.selectQuestionType')}
          blankLabel={t('filter.blankLabelAll')}
          value={filters.values.modality}
          onChange={e => {
            filters.setFieldValue('modality', e.target.value);
          }}
          options={modalitys.map(item => item)}
        />

        <FormCheck
          label={t('filter.checkboxUnreleasedQuestions')}
          checked={filters.values.unused}
          onCheckedChange={checked => filters.setFieldValue('unused', checked)}
        />
        <input
          style={{ position: 'sticky', top: '0' }}
          className="form__control mb-4"
          type="search"
          placeholder={t('exams.placeholderSearchQuestion')}
          onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
        />
      </div>
    </div>
  );
}
